// Hero section component for the landing page

interface HeroSectionProps {
  name?: string;
  title?: string;
  elevatorPitch?: string;
  availabilityStatus?: string;
  onAskAiClick: () => void;
}

// Past companies for the badge row
const COMPANY_BADGES = ['Amazon', 'Indeed', 'Shmoop'];

export function HeroSection({
  name = 'Xavier Pineda',
  title = 'Quality Assurance Engineer',
  elevatorPitch = 'Engineer with expertise in QA automation, NLP, and AI/ML systems.',
  availabilityStatus = 'Open to opportunities',
  onAskAiClick,
}: HeroSectionProps) {
  return (
    <section className="min-h-screen flex items-center pt-16 pb-12">
      <div className="container-custom">
        <div className="max-w-3xl animate-fade-in">
          {/* Status badge */}
          <div className="mb-6">
            <span className="status-badge-available">
              <span className="w-2 h-2 bg-success rounded-full animate-pulse" />
              {availabilityStatus}
            </span>
          </div>

          {/* Main heading */}
          <h1 className="text-hero-mobile md:text-hero font-serif font-bold text-text-primary mb-4 leading-tight">
            {name.split(' ')[0]}
            <span className="text-accent">.</span>
          </h1>

          {/* Title */}
          <h2 className="text-2xl md:text-3xl text-accent font-medium mb-6">
            {title}
          </h2>

          {/* Elevator pitch */}
          <p className="text-lg md:text-xl text-text-secondary mb-8 leading-relaxed">
            {elevatorPitch}
          </p>

          {/* Company badges */}
          <div className="flex flex-wrap gap-2 mb-10">
            <span className="text-sm text-text-muted mr-2">Previously at:</span>
            {COMPANY_BADGES.map((company) => (
              <span key={company} className="company-pill">
                {company}
              </span>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <button onClick={onAskAiClick} className="btn-primary text-lg relative">
              <span className="flex items-center gap-2">
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                  />
                </svg>
                Ask AI About Me
              </span>
              <span className="absolute -top-2 -right-2 px-2 py-0.5 text-xs bg-success text-white rounded-full font-medium">
                New
              </span>
            </button>

            <a href="#experience" className="btn-secondary text-lg">
              View Experience
            </a>
          </div>

          {/* Scroll indicator */}
          <div className="mt-16 flex justify-center animate-bounce">
            <svg
              className="w-6 h-6 text-text-muted"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
